<div class="site-settings-main d-flex flex-column">
  <!-- Header -->
  <div class="header">
    <div class="header-content">
      <h2 class="title-text">{{ "SITE_SETTINGS" | translate }}</h2>
      <div (click)="closeDialog()" class="close-btn-wrapper">
        <img
          src="/assets/svg/ico-hamburger-close.svg"
          class="close-icon pointer-cursor"
          alt="Close"
        />
      </div>
    </div>
  </div>

  <!-- Content -->
  <div class="content-container">
    <div class="my-site-header-card">
      <div class="my-site-header d-flex align-items-center">
        <img
          src="/assets/svg/ico-building-with-black-circle.svg"
          class="site-icon"
          alt="Site Icon"
        />
        <h3 class="section-title">
          <app-with-tooltip [showHelpCursor]="true">
            {{ site?.siteName || ("MY_SITE" | translate) }}
          </app-with-tooltip>
        </h3>
      </div>
    </div>

    <!-- Site Details Card -->
    <div class="site-details-card">
      <div class="info-row">
        <span class="info-label">{{ "ADDRESS_LABEL" | translate }}</span>
        <span class="info-value">
          <app-with-tooltip [showHelpCursor]="true">
            {{ siteAddress }}
          </app-with-tooltip>
        </span>
      </div>
      <div class="info-row">
        <span class="info-label">{{ "TIMEZONE_LABEL" | translate }}</span>
        <span class="info-value">{{ siteTimezone }}</span>
      </div>
    </div>

    <!-- Actions card -->
    <div class="action-items-card">
      <div class="action-item pointer-cursor" (click)="openEditSite()">
        <div class="action-left">
          <img src="/assets/svg/icon-edit.svg" class="action-icon" alt="Edit" />
          <span class="action-text">{{ "EDIT_SITE" | translate }}</span>
        </div>
      </div>

      <div class="action-item pointer-cursor" (click)="openMasterCredential()">
        <div class="action-left">
          <img
            src="/assets/svg/ico-card.svg"
            class="action-icon"
            alt="Credential"
          />
          <span class="action-text">
            {{ "MASTER_CREDENTIAL" | translate }}
          </span>
        </div>

        <img
          src="/assets/svg/ico-chevron-forward-outline.svg"
          class="chevron-icon"
          alt="Arrow"
        />
      </div>
    </div>
  </div>
</div>
